import React, { useState } from "react";
import Faqinside from "../components/Programs/Faqinside";
import Aside from "../modules/SideNav/Aside";

function FaqinsideLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      /> */}
      <Faqinside handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default FaqinsideLayout;
